'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useSearchBox } from 'react-instantsearch';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useUserData from 'data-hooks/useUserData';
import getQuickLinkMatch from './getQuickLinkMatch';

/**
 * When the typed query exactly matches (case insensitive) one of the keywords
 * configured in SEARCH_QUICK_LINKS, or the whole query is an order number
 * (optionally "J-" prefixed), renders a "Go to X page" / "Tracking for order
 * J-XXXXXX" dialog INSTEAD of its children (the search results dropdown), so
 * the results panel never opens for those queries. With no match, renders
 * children untouched.
 */
const QuickLinkDialog = t0 => {
  const $ = _c(15);
  const {
    toggleSearchOpen,
    children,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const {
    query
  } = useSearchBox();
  const currentPage = useUserCurrentPageType();
  const {
    isLoggedIn
  } = useUserData();
  let t2;
  if ($[0] !== query) {
    t2 = getQuickLinkMatch(query);
    $[0] = query;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const match = t2;
  let t3;
  if ($[2] !== currentPage || $[3] !== query || $[4] !== toggleSearchOpen) {
    t3 = () => {
      avo.productsSearched({
        query,
        location: currentPage,
        searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
      });
      toggleSearchOpen?.();
    };
    $[2] = currentPage;
    $[3] = query;
    $[4] = toggleSearchOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClick = t3;
  if (!match) {
    return children || null;
  }
  const ctaText = match.type === "order" ? isLoggedIn ? `Tracking for order J-${match.orderNumber}` : `Log in to track order J-${match.orderNumber}` : `Go to the ${match.pageName} page`;
  const t4 = variant === "mobile";
  let t5;
  if ($[6] !== t4) {
    t5 = classNames("bg-white absolute w-full", {
      "z-[1000]": t4
    });
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== ctaText || $[9] !== handleClick || $[10] !== match.url) {
    t6 = <div className="flex items-center justify-center px-6 py-10"><Link className="bg-gray !text-white text-sm font-bold px-6 py-3 no-underline hover:bg-gray-800 transition-colors" to={match.url} onClick={handleClick} data-xc="search-quick-link-dialog-cta">{ctaText}</Link></div>;
    $[8] = ctaText;
    $[9] = handleClick;
    $[10] = match.url;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t5} data-xc="search-quick-link-dialog">{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
QuickLinkDialog.propTypes = {
  toggleSearchOpen: PropTypes.func,
  children: PropTypes.node,
  variant: PropTypes.string
};
export default QuickLinkDialog;